var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            attrs: {
              model: _vm.form,
              "label-width": "90px",
              "label-position": "top",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "展示类型：" } },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeType },
                    model: {
                      value: _vm.form.goodsType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "goodsType", $$v)
                      },
                      expression: "form.goodsType",
                    },
                  },
                  _vm._l(_vm.filterGoodsEnum, function (rad) {
                    return _c(
                      "el-radio",
                      { key: rad.value, attrs: { label: rad.value } },
                      [_vm._v(_vm._s(rad.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.goodsType === 1
              ? _c(
                  "el-form-item",
                  { attrs: { label: "商品分类：" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        placeholder: "请选择商品分类",
                        options: _vm.comData.showCateIdOption,
                        props: Object.assign({}, _vm.props, { multiple: true }),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.showCateId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showCateId", $$v)
                        },
                        expression: "form.showCateId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.goodsType === 2
              ? _c(
                  "el-form-item",
                  { attrs: { label: "商品标签：" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          clearable: "",
                          placeholder: "请选择标签",
                        },
                        model: {
                          value: _vm.form.labelId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "labelId", $$v)
                          },
                          expression: "form.labelId",
                        },
                      },
                      _vm._l(_vm.comData.goodsLabelEnum, function (opt) {
                        return _c("el-option", {
                          key: opt.id,
                          attrs: { label: opt.labelName, value: opt.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.goodsType === 3
              ? _c(
                  "el-form-item",
                  { attrs: { label: "商品SKU：" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", autosize: "" },
                      model: {
                        value: _vm.form.skuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "skuId", $$v)
                        },
                        expression: "form.skuId",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "tip" }, [
                      _vm._v("商品以,分割，如商品已下架则不展示！"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "商品展示方式：" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.form.goodsShowType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "goodsShowType", $$v)
                      },
                      expression: "form.goodsShowType",
                    },
                  },
                  _vm._l(2, function (i) {
                    return _c(
                      "el-radio",
                      {
                        key: i,
                        staticClass: "goods-show-type",
                        attrs: { label: i },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/componentsLibraryIcons/goodsInterface" +
                              i +
                              ".jpg"),
                          },
                        }),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("span", [_vm._v("边距：")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "左侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.goodsPadding.pl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.goodsPadding, "pl", $$v)
                        },
                        expression: "form.goodsPadding.pl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "顶侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.goodsPadding.pt,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.goodsPadding, "pt", $$v)
                        },
                        expression: "form.goodsPadding.pt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "右侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.goodsPadding.pr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.goodsPadding, "pr", $$v)
                        },
                        expression: "form.goodsPadding.pr",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "底侧" } },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: _vm.form.goodsPadding.pb,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.goodsPadding, "pb", $$v)
                        },
                        expression: "form.goodsPadding.pb",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }